import { render, staticRenderFns } from "./ExaminationRoomSaveBatch.vue?vue&type=template&id=369e4810&"
import script from "./ExaminationRoomSaveBatch.vue?vue&type=script&lang=js&"
export * from "./ExaminationRoomSaveBatch.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationRoomSaveBatch.vue?vue&type=style&index=0&id=369e4810&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports